const hb1eClearFields = [
  "_blsCounties",
  "supervisedRecruitment",
  "empBusinessName",
  "empTradeName",
  "empAddr1",
  "empAddr2",
  "empCity",
  "empState",
  "empPostcode",
  "empCountry",
  "empProvince",
  "empPhone",
  "empPhoneext",
  "empFein",
  "empNaics",
  "empPocLastName",
  "empPocFirstName",
  "empPocMiddleName",
  "empPocJobTitle",
  "empPocAddr1",
  "empPocAddr2",
  "empPocCity",
  "empPocState",
  "empPocPostalCode",
  "empPocCountry",
  "empPocProvince",
  "empPocPhone",
  "empPocPhoneExt",
  "empPocEmail",
  "attyAgRepType",
  "attyAgLastName",
  "attyAgFirstName",
  "attyAgMiddleName",
  "attyAgAddress1",
  "attyAgAddress2",
  "attyAgCity",
  "attyAgState",
  "attyAgPostalCode",
  "attyAgCountry",
  "attyAgProvince",
  "attyAgPhone",
  "attyAgPhoneExt",
  "attyAgEmail",
  "attyAgLawFirmName",
  "attyAgFEIN",
  "primaryWorksiteAddr1",
  "primaryWorksiteAddr2",
  "primaryWorksiteCity",
  "primaryWorksiteCounty",
  "primaryWorksiteState",
  "primaryWorksitePostalCode",
  "primaryWorksiteBlsAreaCode",
  "primaryWorksiteBlsArea",
  "jobOppPWDAttached",
  "jobOppPWDNumber",
  "linkingIsNetwork",
  "linkingAcknowledgedDate",
  "linkingAcknowledgedBy",
  "swaJobOrderStartDate",
  "swaJobOrderEndDate",
  "sundayPaperExists",
  "newspaperNameForAd",
  "newspaperAdPlacedDate",
  "advertisementMethod",
  "journalNameForAd",
  "journalAdPlacedDate",
  "bargainingRep",
  "noBargainingRepPhysical",
  "noBargainingRepElectronic",
  "noBargainingRepInHouse",
  "noBargainingRepPrivate",
  "noBargainingRepNoNotice",
  "isFullTimeEmp",
  "isLiveInHousehold",
  "isPaidExperience",
  "isFwexecutedCont",
  "isEmpProvidedCont",
  "acceptDiplomaPwd",
  "isFwCurrentlyWrk",
  "isFwQualify",
  "empWillAccept",
  "empRelyExp",
  "fwGainExp",
  "empPayEducation",
  "empWorkerInterest",
  "isMultipleLocations",
  "geograpicalArea",
  "pwdWageRate",
  "pwdUnitOfPay",
  "jobFairIncluded",
  "employerWebsiteIncluded",
  "jobSearchWebsiteIncluded",
  "onCampusRecruitingIncluded",
  "tradeProfessionalIncluded",
  "privateEmploymentIncluded",
  "employeeReferralIncluded",
  "campusPlacementIncluded",
  "localEthnicNewspaperIncluded",
  "radioTvAdIncluded",
  "radioTvAdFrom",
  "radioTvAdTo",
  "localEthnicNewspaperFrom",
  "localEthnicNewspaperTo",
  "campusPlacementFrom",
  "campusPlacementTo",
  "employeeReferralFrom",
  "employeeReferralTo",
  "privateEmploymentFrom",
  "privateEmploymentTo",
  "tradeProfessionalFrom",
  "tradeProfessionalTo",
  "onCampusRecruitingFrom",
  "onCampusRecruitingTo",
  "jobSearchWebsiteFrom",
  "jobSearchWebsiteTo",
  "employerWebsiteFrom",
  "employerWebsiteTo",
  "jobFairFrom",
  "jobFairTo",
  "appx_b",
];

const hb1cClearFields = [
  "swaJobOrderStartDate",
  "swaJobOrderEndDate",
  "sundayPaperExists",
  "newspaperNameForAd",
  "newspaperAdPlacedDate",
  "advertisementMethod",
  "journalNameForAd",
  "journalAdPlacedDate",
  "primaryWorksiteType",
  "jobFairIncluded",
  "employerWebsiteIncluded",
  "jobSearchWebsiteIncluded",
  "onCampusRecruitingIncluded",
  "tradeProfessionalIncluded",
  "privateEmploymentIncluded",
  "employeeReferralIncluded",
  "campusPlacementIncluded",
  "localEthnicNewspaperIncluded",
  "radioTvAdIncluded",
  "radioTvAdFrom",
  "radioTvAdTo",
  "localEthnicNewspaperFrom",
  "localEthnicNewspaperTo",
  "campusPlacementFrom",
  "campusPlacementTo",
  "employeeReferralFrom",
  "employeeReferralTo",
  "privateEmploymentFrom",
  "privateEmploymentTo",
  "tradeProfessionalFrom",
  "tradeProfessionalTo",
  "onCampusRecruitingFrom",
  "onCampusRecruitingTo",
  "jobSearchWebsiteFrom",
  "jobSearchWebsiteTo",
  "employerWebsiteFrom",
  "employerWebsiteTo",
  "jobFairFrom",
  "jobFairTo",
];

const hb1aClearFields = ["primaryWorksiteType"];
const hb1bClearFields = ["primaryWorksiteType"];

const clearFileFields = [
  "playerContractAttached",
  "offSeasonAttached",
  "unionLetterAttached",
  "professionalAssociationAttached",
  "teamRevenueAttached",
  "playerStatisticsAttached",
];

const haClearFields = [
  "_blsCounties",
  "empBusinessName",
  "empTradeName",
  "empAddr1",
  "empAddr2",
  "empCity",
  "empState",
  "empPostcode",
  "empCountry",
  "empProvince",
  "empPhone",
  "empPhoneext",
  "empFein",
  "empNaics",
  "empPocLastName",
  "empPocFirstName",
  "empPocMiddleName",
  "empPocJobTitle",
  "empPocAddr1",
  "empPocAddr2",
  "empPocCity",
  "empPocState",
  "empPocPostalCode",
  "empPocCountry",
  "empPocProvince",
  "empPocPhone",
  "empPocPhoneExt",
  "empPocEmail",
  "attyAgRepType",
  "attyAgLastName",
  "attyAgFirstName",
  "attyAgMiddleName",
  "attyAgAddress1",
  "attyAgAddress2",
  "attyAgCity",
  "attyAgState",
  "attyAgPostalCode",
  "attyAgCountry",
  "attyAgProvince",
  "attyAgPhone",
  "attyAgPhoneExt",
  "attyAgEmail",
  "attyAgLawFirmName",
  "attyAgFEIN",
  "primaryWorksiteAddr1",
  "primaryWorksiteAddr2",
  "primaryWorksiteCity",
  "primaryWorksiteCounty",
  "primaryWorksiteState",
  "primaryWorksitePostalCode",
  "primaryWorksiteBlsAreaCode",
  "primaryWorksiteBlsArea",
  "jobOppPWDAttached",
  "jobOppPWDNumber",
  "linkingIsNetwork",
  "linkingAcknowledgedDate",
  "linkingAcknowledgedBy",
  "swaJobOrderStartDate",
  "swaJobOrderEndDate",
  "sundayPaperExists",
  "newspaperNameForAd",
  "newspaperAdPlacedDate",
  "advertisementMethod",
  "journalNameForAd",
  "journalAdPlacedDate",
  "bargainingRep",
  "noBargainingRepPhysical",
  "noBargainingRepElectronic",
  "noBargainingRepInHouse",
  "noBargainingRepPrivate",
  "noBargainingRepNoNotice",
  "isFullTimeEmp",
  "isLiveInHousehold",
  "isPaidExperience",
  "isFwexecutedCont",
  "isEmpProvidedCont",
  "acceptDiplomaPwd",
  "isFwCurrentlyWrk",
  "isFwQualify",
  "empWillAccept",
  "empRelyExp",
  "fwGainExp",
  "empPayEducation",
  "jobEmpPremises",
  "jobComboOccup",
  "jobForeignLanguage",
  "jobReqExceed",
  "empUseCredential",
  "emprecpayment",
  "emPlayoff",
  "empWorkerInterest",
  "isMultipleLocations",
  "geograpicalArea",
];

export default {
  name: "Preliminary Questions",
  symbol: "document",
  pageInfo: {
    text: `<b>IMPORTANT:</b> Please read these instructions carefully before completing the Form ETA-9089 – <i>Application for Permanent Employment Certification</i> and Appendices A to D.  These instructions contain full explanations of the questions and attestations that make up the Form ETA-9089 and Appendices A to D.  For applications submitted by mail, the Form ETA-9089, the Form ETA-9089 – General Instructions, and Appendices A to D, are available to be downloaded from the Office of Foreign Labor Certification website at <a style='color:LinkText' target="_blank" href="https://www.dol.gov/agencies/eta/foreign-labor">https://www.dol.gov/agencies/eta/foreign-labor</a>. All filers must review the Form ETA-9089 for completeness and accuracy prior to submission electronically or by mail. <b><i>In accordance with 20 CFR 656.17(a), incomplete applications will not be certified by the Department of Labor (Department or DOL).</i></b>
    <br/>
    <br/>
    <b><i>Those items marked with an asterisk (*) are required and must be completed.  Items marked with a section symbol (§) are conditional and must be completed if applicable.  If submitting this form non-electronically, <u>ALL</u> fields/items must be completed.  In fields/items for which there is no answer, enter “N/A” or “0” (zero) if the field/item is a number field.  If submitting this form electronically, you may leave fields/items for which there is no answer blank, and, at the end of each page, you will be asked to confirm your desire to leave these fields/items blank.  When the application is printed, all fields/items intentionally left blank will be automatically pre-populated with “N/A.”  Although not required, applications and documents submitted by mail should include a cover page with the full name, job title, address, and phone number of the employer’s point of contact with an index for the documents included with the application.</i></b>
    <br/>
    <br/>
    Anyone who knowingly and willingly furnishes any false information in the preparation of Form ETA-9089 and any supporting documentation, or aids, abets, or counsels another to do so is committing a federal offense, punishable by fines, imprisonment or both (18 U.S.C. 2, 1001, 1546, 1621).<br/><br/>
    Employing or continuing to employ a foreign worker unauthorized to work in the United States is illegal and may subject the employer to criminal prosecution, civil money penalties, or both.
    <br/>
    <br/>
    <hr/>
    <br/>
    <span style="color:#B50906"><b>IMPORTANT NOTICE!</b><br/><br/> Based on your response, an employer seeking to sponsor a foreign worker for permanent employment in a qualifying occupation included on Schedule A or sheepherding DOES NOT file the Form ETA-9089 with the Department of Labor.  The FLAG system does not support the preparation or submission of these applications for permanent labor certification.
    <br/>
    <br/>
    In accordance with 20 CFR 656.15(a) and 656.16(a), please complete and submit an uncertified Form ETA-9089, including all other required forms and documentation, directly to the United States Citizenship and Immigration Services (USCIS), Department of Homeland Security, at the time of filing the Immigrant Petition for Alien Workers, Form I-140.
    <br/>
    <br/>
    A fillable PDF version of Form ETA-9089 is available on the <u><a target="_blank" style='color:LinkText' href="https://www.dol.gov/agencies/eta/foreign-labor/forms">OFLC website</a></u>.
    <br/>
    <br/>
    More information on the filing of the petition Form I-140 for an occupation included on Schedule A or sheepherding is available on the <u><a target="_blank" style='color:LinkText' href="https://www.uscis.gov/i-140">USCIS website</a></u><span>
    <br/><br/>
    <b><u>Note: </u></b> This is information will capture the employer’s recruitment efforts. Each section is specifically designed to determine if the appropriate recruitment type was used and that the recruitment and Notice of Filing was conducted within the required timeframes, in accordance with 20 CFR 656.10, 656.17, 656.18, and 656.21.
    `,
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          isGroup: {
            code: "H.b",
            machine_name: "occupationType",
            required: true,
            label: `Occupation Type - All must complete this section. Mark ONE appropriate box below:`,
            clearBtn: {
              clearSchema: [""],
            },
            tooltip: `<b><u>Note:</u></b> In accordance with 20 CFR 656.20, non-professional occupation means any occupation for which the 
              attainment of a bachelor's or higher degree is not a usual requirement for the occupation.  Only mark one box.
              <br/>
              <br/>
              1a. Mark this box if the job opportunity is for a professional occupation other than a college or university teacher filing under 20 CFR 656.18
              <br/>
              <br/>
              1b. Mark this box if the job opportunity is for a non-professional occupation.
              <br/>
              <br/>
              1c. Mark this box if the job opportunity is for a college or university teacher.
              <br/>
              <br/>
              <div style="margin-left: 10px;"><b><u>Note:</u></b> If this option is selected, skip subsections H.c and H.d below. The employer must submit a completed Appendix D with this application.</div>
              <br/>
              <br/>
              1d. Mark this box if the job opportunity is for a Schedule A occupation or sheepherders.
              <br/>
              <br/>
              <div style="margin-left: 10px;"><b>Note:</b> Schedule A occupation and sheepherder applications must be submitted directly to United States 
              Citizenship and Immigration Services (USCIS). If selected, this case will not be submitted to the Department.</div>
              <br/>
              <br/>
              1e. Mark this box if this job opportunity is for a professional athlete.
              `,
            coloring: "none",
            fields: [
              {
                widget: "radio",
                choice:
                  "1a. This application is for a <b>professional occupation</b> (which includes a college or university teacher <u>not</u> selected using the competitive recruitment process) and the recruiting was conducted in accordance with 20 CFR 656.17(e)(1).",
                value: "professional_occupation",
                validate: ["required"],
                clearFiles: clearFileFields,
                clearSchema: hb1aClearFields,
              },
              {
                widget: "radio",
                choice:
                  "1b. This application is for a <b>non-professional occupation</b> and the recruiting was conducted in accordance with 20 CFR 656.17(e)(2).",
                value: "non_professional",
                validate: ["required"],
                clearFiles: clearFileFields,
                clearSchema: hb1bClearFields,
              },
              {
                widget: "radio",
                choice:
                  "1c. This application is for a <b>college or university teacher</b> <u>and</u> the candidate was selected using the <b>competitive recruitment process</b> in accordance with 20 CFR 656.18. (Skip c. and d. of Section H. and go to Appendix D)",
                value: "college_university_teacher",
                validate: ["required"],
                clearSchema: hb1cClearFields,
                clearFiles: clearFileFields,
              },
              {
                widget: "radio",
                choice:
                  "<span style='color:#707275'>1d. None of the above apply because this application is for a <b>Schedule A or sheepherder occupation</b>.</span>",
                value: "schedule_a",
                disabled: true,
                validate: ["required"],
                clearFiles: clearFileFields,
              },
              {
                widget: "radio",
                choice:
                  "1e. None of the above apply because this application is for a <b>professional athlete</b>.",
                value: "professional_athlete",
                validate: ["required"],
                setSchema: [
                  { set: "jobOppPWDAttached", to: "N/A" },
                  { set: "primaryWorksiteType", to: "1" },
                  { set: "isAppdendixBAttached", to: 2 },
                ],
                clearFiles: ["supervisedRecruitmentAttached"],
                clearSchema: hb1eClearFields,
              },
            ],
          },
        },
      ],
    },
    {
      isVisible: {
        when: "occupationType",
        is: [
          "professional_occupation",
          "non_professional",
          "college_university_teacher",
        ],
        operator: "||",
      },
      fields: [
        {
          isGroup: {
            code: "H.a",
            machine_name: "supervisedRecruitment",
            required: true,
            label: `Is the employer required, by notice from a Certifying Officer, to currently undergo supervised recruitment in accordance with 20 CFR 656.21?`,
            tooltip:
              "Indicate if the employer was notified that it must conduct supervised recruitment by marking “Yes” or “No.”  Only select “Yes” if the employer has either received a Notice of Supervised Recruitment or a determination letter that specifically requires the employer to file the application via supervised recruitment.",
            clearBtn: {
              clearSchema: [],
            },
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
                clearSchema: haClearFields,
                setSchema: [
                  { set: "jobOppPWDAttached", to: "Yes" },
                  { set: "appx_b", to: [] },
                ],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
                clearFiles: ["supervisedRecruitmentAttached"],
                clearSchema: haClearFields,
                setSchema: [
                  { set: "jobOppPWDAttached", to: "N/A" },
                  { set: "appx_b", to: [] },
                ],
              },
            ],
          },
        },
      ],
    },
    {
      // name: "Please upload the Notice of Supervised Recruitment (NSR) (Mandatory)", // Currently replaced to maintain uniformity
      name: "Document Upload - Notice of Supervised Recruitment(NSR) (Mandatory)",
      divider: "hide",
      isVisible: {
        when: "supervisedRecruitment",
        is: ["Yes"],
        operator: "||",
      },
      fields: [
        {
          machine_name: "supervisedRecruitmentAttached",
          name: "Notice of Supervised Recruitment",
          widget: "file_upload",
          uploadTitle: "Document Upload - Notice of Supervised Recruitment",
          label: "Please upload the Notice of Supervised Recruitment(NSR).",
          // fileTypes: [".pdf", ".png", ".jpg"],
          fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
          validate: ["required", "checkValue"],
        },
      ],
    },
    {
      coloring: "grey",
      isVisible: {
        when: "supervisedRecruitment",
        is: ["Yes", "No"],
        operator: "||",
      },
      fields: [
        {
          code: "",
          machine_name: "jobOppPWDNumber",
          widget: "pw_lookup",
          label: `<b>Form ETA 9141 Case Lookup</b> <br/><br/>E.1: Enter the valid Prevailing Wage Determination (PWD) case number issued by the Department of Labor to identify the job opportunity and prevailing wage(s) covered by this application.<br/><br/>E.2: If a valid PWD has not been obtained due to the employer being required, by notice from a Certifying Officer, to currently undergo supervised recruitment in accordance with 20 CFR 656.21, indicate whether a completed Form ETA-9141 is attached to this application.`,
          validate: [
            {
              requiredWithCustomMessage:
                "You must link a prevailing wage determination to this case.",
            },
            "pNumberCheck",
          ],
          info: "If you do not have a relevant Form ETA-9141, Application for Prevailing Wage Determination, please complete one and return to this form once you have submitted.",
          pw_lookup: {
            formType: {
              this: "9141",
              to: "9089",
            },
            PWFields: {
              PWLinkingFields: ["jobOppPWDNumber"],
            },
            worksiteFields: {
              importedWorksites: "appx_b",
              chosenWorksites: "appx_b_worksites",
              bls_counties: "_blsCounties",
            },
            showLinkedPWDLink: true,
            emergencyField: "supervisedRecruitment",
            // icertView: true,
            buttonPrimary: "PWD Case Lookup",
            redirectToForm: "9141",
          },
        },
        // {
        //   widget:"inlinePrefiller",
        //   label:"<span style='color:grey'>ⓘ Important Reminder: In order to submit a Form ETA-9089 (PERM Application) for a job opportunity where the employer is currently required to undergo supervised recruitment with the OFLC Certifying Officer, you must first submit a prevailing wage request, Form ETA-9141, covering the job opportunity through your FLAG system account and obtain a Prevailing Wage Determination (PWD) Case Number. Once the Form ETA-9141 is submitted for processing, you may return to this screen, link your submitted PWD Case Number to this initiated PERM application, and continue the submission process.</span> <br/><br/> <a href='javascript:void(0)'> Click here to prepare and submit a Form ETA-9141</a><br/><br/><b style='color:red'> You must link a prevailing wage determination to this case</b>",
        // },
      ],
    },
    {
      // name: "You must upload your Player Contract (Mandatory)", // Currently replaced to maintain uniformity
      name: "Document Upload - Player Contract (Mandatory)",
      divider: "hide",
      isVisible: {
        when: "occupationType",
        is: ["professional_athlete"],
        operator: "||",
      },
      fields: [
        {
          machine_name: "playerContractAttached",

          name: "Player Contract",
          widget: "file_upload",
          uploadTitle: "Document Upload - Player Contract",
          label:
            "You must upload your Player Contract.<br><br>Copies of any written contracts or summaries of the terms of oral agreements containing the terms of the worker’s current employment including wage or salary.</span>",
          fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
          validate: ["required", "checkValue"],
        },
      ],
    },
    {
      // name: "You must upload your Off Season letter (Mandatory)", // Currently replaced to maintain uniformity
      name: "Document Upload - Off Season Letter (Mandatory)",
      divider: "hide",
      isVisible: {
        when: "occupationType",
        is: ["professional_athlete"],
        operator: "||",
      },
      fields: [
        {
          machine_name: "offSeasonAttached",
          name: "Off Season Letter",
          widget: "file_upload",
          uploadTitle: "Document Upload - Off Season Letter",
          label:
            "You must upload your Off Season letter.<br><br>Documentation that the job is permanent and year-round in nature, not temporary. It should indicate the number of hours worked per week during the off season and confirm work of at least 10 hours per week in the off season.</span>",
          fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
          validate: ["required", "checkValue"],
        },
      ],
    },
    {
      // name: "You may upload your Union/No Objection letter (Optional)", // Currently replaced to maintain uniformity
      name: "Document Upload - Union/No Objection Letter (Optional)",
      divider: "hide",
      isVisible: {
        when: "occupationType",
        is: ["professional_athlete"],
        operator: "||",
      },
      fields: [
        {
          machine_name: "unionLetterAttached",
          name: "Union Letter/No Objection Letter",
          widget: "file_upload",
          uploadTitle: "Document Upload - Union/No Objection Letter",
          label:
            "You may upload your Union/No Objection letter.<br><br>A written consultation from an appropriate labor organization describing the work or services to be performed in the United States and the worker’s qualifications for such work. The labor organization may also submit a letter of no objection to the approval of the petition.</span>",
          fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
        },
      ],
    },
    {
      // name: "You may upload your Professional Association document (Optional) // Currently replaced to maintain uniformity
      name: "Document Upload - Professional Association Document (Optional)",
      divider: "hide",
      isVisible: {
        when: "occupationType",
        is: ["professional_athlete"],
        operator: "||",
      },
      fields: [
        {
          machine_name: "professionalAssociationAttached",
          name: "Professional Association",
          widget: "file_upload",
          uploadTitle: "Document Upload - Professional Association Document",
          label:
            "You may upload your Professional Association document.<br><br>Documentation that establishes the worker will be working for a team located in the United States that is a member of an association of six or more professional sports teams. Also, evidence that the association governs the conduct of its members and regulates the contests and exhibitions in which its member teams regularly engage.</span>",
          fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
        },
      ],
    },
    {
      // name: "You may upload your Team Revenue document (Optional)", // Currently replaced to maintain uniformity
      name: "Document Upload - Team Revenue Document (Optional)",
      divider: "hide",
      isVisible: {
        when: "occupationType",
        is: ["professional_athlete"],
        operator: "||",
      },
      fields: [
        {
          machine_name: "teamRevenueAttached",
          name: "Team Revenue",
          widget: "file_upload",
          uploadTitle: "Document Upload - Team Revenue Document",
          label:
            "You may upload your Team Revenue document.<br><br>Documentation that establishes that the total combined revenues of the association’s teams exceeds $10 million per year.</span>",
          fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
        },
      ],
    },
    {
      // name: "You must upload News Clippings/Player Statistics document (Mandatory)", // Currently replaced to maintain uniformity
      name: "Document Upload - News Clippings/Player Statistics Document (Mandatory)",
      divider: "hide",
      isVisible: {
        when: "occupationType",
        is: ["professional_athlete"],
        operator: "||",
      },
      fields: [
        {
          machine_name: "playerStatisticsAttached",
          name: "News Clippings/Player Statistics",
          widget: "file_upload",
          uploadTitle:
            "Document Upload - News Clippings/Player Statistics Document",
          label:
            "You must upload News Clippings/Player Statistics document.<br><br>Documentation attesting to the worker’s preeminence or star status/sustained participation in major league sports.</span>",
          fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
          validate: ["required", "checkValue"],
        },
      ],
    },
  ],
};
